import React from 'react'
import axios from 'axios'
import './App.css'
const quoteAPI = "https://gist.githubusercontent.com/camperbot/5a022b72e96c4c9585c32bf6a75f62d9/raw/e3c6895ce42069f0ee7e991229064f167fe8ccdc/quotes.json"
export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quote: "The present is theirs; the future, for which I really worked, is mine.",

      author: "Nikola Tesla",
      quotesArr: '',
      authorArr: ''
    };
    this.next = this.next.bind(this)
  }
  componentDidMount() {
    axios.get(quoteAPI).then((res) => {
      console.log(res.data)
      for (let i = 0; i < res.data.quotes.length; i++) {
        this.setState(({
          quotesArr: [...this.state.quotesArr, res.data.quotes[i].quote],
          authorArr: [...this.state.authorArr, res.data.quotes[i].author]
        }))
      }
    })
  }
  next() {
    const randomIndex = Math.floor(Math.random() * this.state.quotesArr.length)
    this.setState(({
      quote: this.state.quotesArr[randomIndex],
      author: this.state.authorArr[randomIndex]
    }))
  }
  render() {
    return (
      <div>
        <h2>"{this.state.quote}"</h2>
        <h3>{this.state.author}</h3>
        <button onClick={this.next}><i class="fas fa-chevron-circle-right"></i></button>
        <footer>Created By <a href="https://twitter.com/avinaashdhumal" target="_blank">Avinash</a></footer>
      </div>
    )
  }
}